import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/pandas.png'


const _withScopeId = n => (_pushScopeId("data-v-75b873b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-md-9 col-xs-12 px-3 mx-auto" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"not_found-card bg-dark shadow p-4\" data-v-75b873b0><div class=\"d-flex align-items-center\" data-v-75b873b0><h6 class=\"text-white mb-0\" data-v-75b873b0>Не найдено</h6><i class=\"far fa-window-restore\" data-v-75b873b0></i></div><hr class=\"border-3 opacity-100\" data-v-75b873b0><div class=\"row\" data-v-75b873b0><div class=\"col my-5 text-center\" data-v-75b873b0><img src=\"" + _imports_0 + "\" class=\"img-fluid mb-3\" alt=\"Панда\" data-v-75b873b0><h5 class=\"text-light\" data-v-75b873b0>Упс! Страница, которую вы запрашиваете, не существует</h5><small class=\"text-light\" data-v-75b873b0>Попробуйте вернуться на <a href=\"/\" style=\"color:#5faaff;\" data-v-75b873b0>главную</a></small></div></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

import { defineComponent } from 'vue';
import {useHead} from "@unhead/vue";
import UseHeadService from "@/services/UseHeadService";


export default /*#__PURE__*/_defineComponent({
  __name: 'NotFoundView',
  setup(__props) {

defineComponent({
  name: 'NotFoundView',
  setup() {
    const title = 'Страница не найдена - Modbox: скачать моды для игр'
    UseHeadService.title = title
    UseHeadService.description = 'Страница не найдена - Modbox: скачать моды для игр'

    useHead({
      title: title,
      meta: UseHeadService.getMetaInfo(true),
    });
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})